// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1dmYQ","validationTips":"StatementDescriptor_validationTips__23rVS"};